import styled, { css } from 'styled-components';
import { azure } from '@spotify-internal/encore-foundation';

export const PAGE_GUTTER = '148px';

export const pageConstraintStyles = css`
  margin: 0 auto;
  max-width: 1280px;
`;

export const AzureLink = styled.a`
  color: ${azure};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
